import { useState } from "react";

import { ActionsMenu, MenuItem } from "ui/actions-menu";

import Icons from "assets";

import type { CampaignTemplate } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

interface CampaignTemplateActionsMenuProps {
  template: CampaignTemplate;
  onViewTemplate: (templateId: string) => void;
  onArchiveTemplate: (template: CampaignTemplate) => void;
}

const CampaignTemplateActionsMenu = ({
  template,
  onViewTemplate,
  onArchiveTemplate,
}: CampaignTemplateActionsMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const handleViewTemplate = () => {
    setIsOpen(false);
    onViewTemplate(template.id);
  };

  const handleArchiveTemplate = () => {
    setIsOpen(false);
    onArchiveTemplate(template);
  };

  return (
    <ActionsMenu
      itemName={template.name}
      open={isOpen}
      onOpen={handleMenuOpen}
      onClose={handleMenuClose}
      sx={{ justifyContent: "flex-end", pr: 0.75 }}>
      <MenuItem
        icon={<Icons.EyeVisible />}
        label="View brief details"
        onClick={handleViewTemplate}
      />
      <MenuItem
        icon={<Icons.Archive />}
        label="Archive brief"
        color="error"
        onClick={handleArchiveTemplate}
      />
    </ActionsMenu>
  );
};

export default CampaignTemplateActionsMenu;
